import { api } from "@/v5/lib/api";

export interface SmsTemplateSummary {
  id: string;
  name: string;
}

export interface SmsCategory {
  id: string;
  name: string;
  templates: SmsTemplateSummary[];
}

export interface MostUsedTemplate {
  id: string;
  name: string;
  useCount: number;
}

export async function fetchSmsTemplateList(): Promise<SmsCategory[]> {
  const data = await api<{ categories: SmsCategory[] }>("/sms-templates/picker");
  return data.categories ?? [];
}

export async function fetchSmsTemplate(
  id: string,
  patientID?: string,
  planID?: string,
): Promise<{ message: string }> {
  const qs = new URLSearchParams();
  if (patientID) qs.set("patientID", patientID);
  if (planID) qs.set("planID", planID);
  const params = qs.toString() ? `?${qs.toString()}` : "";
  return api<{ message: string }>(`/sms-templates/picker/${encodeURIComponent(id)}${params}`);
}

export async function fetchSmsMostUsed(): Promise<MostUsedTemplate[]> {
  const data = await api<{ templates: MostUsedTemplate[] }>(
    "/sms-templates/picker/most-used",
  );
  return data.templates ?? [];
}

export async function resetSmsMostUsed(id: string): Promise<void> {
  await api(`/sms-templates/picker/most-used/${encodeURIComponent(id)}`, {
    method: "DELETE",
  });
}
